import { MOCK_LIVE_STREAMS } from '@/features/marketing/mockData/streamEvents'

/**
 * Tournament multi-stream mockup. Shows the Stadium-style multi-feed
 * grid: 2x2 of live POVs, each labelled with the captain. Sells the
 * "watch every angle of a tournament from one URL" feature.
 *
 * Each cell is its own thumbnail with a live pip + nameplate.
 * The bottom strip surfaces the tournament context so the visitor
 * knows this isn't a generic Twitch grid — it's "the Saturday
 * Bracket Night, all four POVs".
 */
export function MultiStreamMockup() {
  return (
    <div className="flex aspect-video w-full flex-col overflow-hidden bg-[#06060f] text-white">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-white/10 bg-[#11112a]/80 px-4 py-2">
        <p className="font-display text-xs font-extrabold tracking-tight">
          Saturday Bracket Night · QF Round
        </p>
        <span className="font-display inline-flex items-center gap-1 rounded-full border border-success/40 bg-success/10 px-2 py-0.5 text-[9px] font-extrabold tracking-[0.2em] text-success uppercase">
          <span className="size-1 rounded-full bg-success" />
          4 live POVs
        </span>
      </div>

      {/* 2x2 grid */}
      <div className="grid flex-1 grid-cols-2 grid-rows-2 gap-px bg-black/40">
        {MOCK_LIVE_STREAMS.map((s) => (
          <div key={s.twitchLogin} className="relative overflow-hidden">
            <img
              src={s.thumbnailUrl}
              alt=""
              className="h-full w-full object-cover"
              loading="lazy"
            />
            {/* Vignette for legibility */}
            <div
              aria-hidden
              className="absolute inset-0"
              style={{
                background:
                  'linear-gradient(180deg, rgba(0,0,0,0.0) 60%, rgba(0,0,0,0.7) 100%)',
              }}
            />
            <span className="font-display absolute left-1.5 top-1.5 inline-flex items-center gap-1 rounded-sm bg-danger px-1.5 py-[1px] text-[8px] font-extrabold tracking-[0.18em] text-white uppercase">
              <span className="size-1 rounded-full bg-white" />
              Live
            </span>
            <span className="font-display absolute right-1.5 top-1.5 rounded-sm bg-black/70 px-1.5 py-[1px] text-[9px] font-bold text-white tabular-nums">
              {s.viewerCount}
            </span>
            <div className="absolute bottom-1.5 left-1.5 right-1.5 flex items-center gap-1.5">
              <img
                src={s.avatarUrl}
                alt=""
                className="size-5 rounded-full border border-white/80"
                loading="lazy"
              />
              <p className="font-display truncate text-[10px] font-bold text-white">
                {s.streamerCallsign}
              </p>
              <p className="font-display ml-auto shrink-0 rounded-sm bg-black/60 px-1 text-[9px] text-white/80">
                {s.gameName}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer ticker */}
      <div className="flex items-center gap-3 border-t border-white/10 bg-[#11112a]/80 px-4 py-2">
        <span className="font-display text-[9px] font-extrabold tracking-[0.22em] text-primary uppercase">
          Bracket
        </span>
        <span className="text-[10px] text-white/80">QF · 4 matches in progress · GF at 22:00</span>
      </div>
    </div>
  )
}
